import React from 'react';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';

import Image from 'next/legacy/image';
import CovidIcon from 'components/svg/covid.svg';

const defaultIcon = <StarBorderRoundedIcon />;

const iconsByAttributes = {
  internal_passport_required: (
    <Image
      src="/static/svg/editEventIcons/internal_passport_required.svg"
      alt="internal_passport_required"
      width={24}
      height={24}
      priority
    />
  ),
  parking: (
    <Image src="/static/svg/editEventIcons/parking-info.svg" alt="parking-info" width={24} height={24} priority />
  ),
  arrival_check_in: (
    <Image
      src="/static/svg/editEventIcons/ico-arrival-checkout.svg"
      alt="ico-arrival-checkout"
      width={24}
      height={24}
    />
  ),
  forms: <Image src="/static/svg/editEventIcons/forms.svg" alt="forms" width={24} height={24} priority />,
  dress_code: <CovidIcon priority />,
  general_update: <Image src="/static/svg/editEventIcons/bell.svg" alt="bell" width={24} height={24} priority />,
  custom: (
    <Image
      src="/static/svg/editEventIcons/ico-health-and-wellness.svg"
      alt="ico-health-and-wellness"
      width={24}
      height={24}
      priority
    />
  ),
  games: <Image src="/static/svg/editEventIcons/games.svg" alt="games" width={24} height={24} priority />,
  kosher: <Image src="/static/svg/editEventIcons/ico-kosher.svg" alt="ico-kosher" width={24} height={24} priority />,
  'parking-free': (
    <Image src="/static/svg/editEventIcons/parking-free.svg" alt="parking-free" width={24} height={24} priority />
  ),
  'cocktails-and-drinks': (
    <Image
      src="/static/svg/editEventIcons/coctails-and-drinks.svg"
      alt="coctails-and-drinks"
      width={24}
      height={24}
      priority
    />
  ),
  'alc-drinks-for-purchase': (
    <Image
      src="/static/svg/editEventIcons/coctails-and-drinks.svg"
      alt="alc-drinks-for-purchase"
      width={24}
      height={24}
      priority
    />
  ),
  'kids-area': (
    <Image src="/static/svg/editEventIcons/ico-kids-area.svg" alt="ico-kins-area" width={24} height={24} priority />
  ),
  'beverages-provided': (
    <Image
      src="/static/svg/editEventIcons/ico-food-provided.svg"
      alt="ico-food-provided"
      width={24}
      height={24}
      priority
    />
  ),
  'non-alc-drinks-for-purchase': (
    <Image
      src="/static/svg/editEventIcons/ico-food-provided.svg"
      alt="non-alc-drinks-for-purchase"
      width={24}
      height={24}
      priority
    />
  ),
  'valet-parking': (
    <Image src="/static/svg/editEventIcons/valet-parking.svg" alt="valet-parking" width={24} height={24} priority />
  ),
  'special-guest': (
    <Image
      src="/static/svg/editEventIcons/ico-health-and-wellness.svg"
      alt="icon-health-and-wellness"
      width={24}
      height={24}
      priority
    />
  ),
  accessibility: (
    <Image
      src="/static/svg/editEventIcons/wheelchair-accessible.svg"
      alt="wheelchair-accessible"
      width={24}
      height={24}
      priority
    />
  ),
  'wheelchair-accessible': (
    <Image
      src="/static/svg/editEventIcons/wheelchair-accessible.svg"
      alt="wheelchair-accessible"
      width={24}
      height={24}
      priority
    />
  ),
  'english-speaking': (
    <Image
      src="/static/svg/editEventIcons/english-speaking.svg"
      alt="english-speaking"
      width={24}
      height={24}
      priority
    />
  ),
  'hebrew-speaking': (
    <Image src="/static/svg/editEventIcons/hebrew-speaking.svg" alt="hebrew-speaking" width={24} height={24} priority />
  ),
  outdoors: (
    <Image src="/static/svg/editEventIcons/outdoors-nature.svg" alt="outdoors" width={24} height={24} priority />
  ),
  'food-provided': (
    <Image src="/static/svg/editEventIcons/food-provided.svg" alt="food-provided" width={24} height={24} priority />
  ),
  food_provided: (
    <Image src="/static/svg/editEventIcons/food-provided.svg" alt="food_provided" width={24} height={24} priority />
  ),
  'beverages-non-alcoholic': (
    <Image
      src="/static/svg/editEventIcons/ico-food-provided.svg"
      alt="beverages-non-alcoholic"
      width={24}
      height={24}
      priority
    />
  ),
  'food-available': (
    <Image src="/static/svg/editEventIcons/food-provided.svg" alt="food-available" width={24} height={24} priority />
  ),
  'vegetarian-friendly': (
    <Image
      src="/static/svg/editEventIcons/vegetarian-friendly.svg"
      alt="vegetarian-friendly"
      width={24}
      height={24}
      priority
    />
  ),
  'valet-parking-free': (
    <Image
      src="/static/svg/editEventIcons/valet-parking.svg"
      alt="valet-parking-free"
      width={24}
      height={24}
      priority
    />
  ),
  wifi: <Image src="/static/svg/editEventIcons/ico-free-wifi.svg" alt="wifi" width={24} height={24} priority />,
  'closed-captions': (
    <Image src="/static/svg/editEventIcons/closed-captions.svg" alt="closed-captions" width={24} height={24} priority />
  ),
  'french-speaking': (
    <Image src="/static/svg/editEventIcons/french-speaking.svg" alt="french-speaking" width={24} height={24} priority />
  ),
  'yiddish-speaking': (
    <Image
      src="/static/svg/editEventIcons/yiddish-speaking.svg"
      alt="yiddish-speaking"
      width={24}
      height={24}
      priority
    />
  ),
  nature: <Image src="/static/svg/editEventIcons/outdoors-nature.svg" alt="nature" width={24} height={24} priority />,
  check_in: (
    <Image src="/static/svg/editEventIcons/ico-arrival-checkout.svg" alt="check_in" width={24} height={24} priority />
  ),
  'arcade-games': (
    <Image src="/static/svg/editEventIcons/arcade-games.svg" alt="arcade-games" width={24} height={24} priority />
  ),
  'finger-food': (
    <Image src="/static/svg/editEventIcons/finger-food.svg" alt="finger-food" width={24} height={24} priority />
  ),
  'kosher-food': (
    <Image src="/static/svg/editEventIcons/ico-kosher-food.svg" alt="kosher-food" width={24} height={24} priority />
  ),
  kosher_food: (
    <Image src="/static/svg/editEventIcons/ico-kosher-food.svg" alt="kosher_food" width={24} height={24} priority />
  ),
  'items-for-sale': (
    <Image
      src="/static/svg/editEventIcons/ico-special-gifts.svg"
      alt="items-for-sale"
      width={24}
      height={24}
      priority
    />
  ),
  'russian-speaking': (
    <Image
      src="/static/svg/editEventIcons/russian-speaking.svg"
      alt="russian-speaking"
      width={24}
      height={24}
      priority
    />
  ),
  'desserts-provided': (
    <Image
      src="/static/svg/editEventIcons/desserts-provided.svg"
      alt="desserts-provided"
      width={24}
      height={24}
      priority
    />
  ),
  educational: (
    <Image src="/static/svg/editEventIcons/ico-educational.svg" alt="educational" width={24} height={24} priority />
  ),
  transportation_available: (
    <Image
      src="/static/svg/editEventIcons/transportation-available.svg"
      alt="transportation_available"
      width={24}
      height={24}
      priority
    />
  ),
  сhildcare: (
    <Image
      src="/static/svg/editEventIcons/childcare.png"
      alt="transportation_available"
      width={24}
      height={24}
      priority
    />
  ),
};

export const getIconByAttribute = (slug: string) => {
  const icon = iconsByAttributes[slug as keyof typeof iconsByAttributes];
  if (icon) return icon;
  return defaultIcon;
};

export const getIconByAttributeSrc = (slug: string) => {
  const icon = iconsByAttributes[slug as keyof typeof iconsByAttributes];
  if (icon?.props?.src) return icon.props.src;
  return defaultIcon;
};
